import {Component, inject, Input, OnInit} from '@angular/core';
import {SupportWidgetCmsData} from '@app/checkout/checkout-support-widget/checkout-support-widget.component';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';
import {PxSurveyService} from '@app/services/px-survey/px-survey.service';
import {ChatAdvisorPageService} from '@dcp/configurator';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {PxSurveyWidgetComponent} from '../px-survey/px-survey-widget.component';
import {CheckoutSupportWidgetComponent} from '../../checkout/checkout-support-widget/checkout-support-widget.component';
import {AsyncPipe} from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'dcp-shared-widgets',
  templateUrl: './shared-widgets.component.html',
  styleUrls: ['./shared-widgets.component.scss'],
  imports: [PxSurveyWidgetComponent, CheckoutSupportWidgetComponent, AsyncPipe],
})
export class SharedWidgetsComponent implements OnInit {
  @Input()
  public componentData: SupportWidgetCmsData;
  public shouldShowPxUserSurvey$: Observable<boolean>;
  showSupportWidget$: Observable<boolean>;

  private readonly pxSurveyService = inject(PxSurveyService);
  private readonly chatAdvisorPageService = inject(ChatAdvisorPageService);

  public ngOnInit(): void {
    this.shouldShowPxUserSurvey$ = this.pxSurveyService.shouldEnablePxSurvey(
      UNLEASH_TOGGLES.pxUserInitiatedSurveyEnabled,
    );

    // Show the support (Contact Us) widget whenever Joule is not shown. Gate on showChatAdvisor$
    // (which respects the master toggle), not advisorActiveOnPage$ (which ignores it) — otherwise a
    // page whose sub-toggle is ON while the master toggle is OFF would hide both Joule and Contact Us.
    this.showSupportWidget$ = this.chatAdvisorPageService.showChatAdvisor$.pipe(map((shown) => !shown));
  }
}
